const goToCurrentLocation = (map: google.maps.Map) => {
  var options = {
    enableHighAccuracy: true,
    timeout: 50000,
    maximumAge: 0,
  }

  function success(pos: { coords: { latitude: number; longitude: number } }) {
    var crd = pos.coords
    map.panTo({ lat: crd.latitude, lng: crd.longitude })
    if (map.getZoom() !== 16) {
      map.setZoom(16)
    }
  }

  function error(err: { code: number; message: string }) {
    console.warn(`ERROR(${err.code}): ${err.message}`)
  }

  navigator.geolocation.getCurrentPosition(success, error, options)
}

export const cutsomControls = (map: google.maps.Map) => {
  // Custom zoom buttons
  var controls = document.createElement('div')
  var mapGroupZoom = document.createElement('div')
  var mapGroupLocation = document.createElement('div')
  mapGroupZoom.classList.add('maps-button-group')
  mapGroupLocation.classList.add('maps-button-group')

  var zoomInButton = document.createElement('button')
  zoomInButton.classList.add('maps-button')
  zoomInButton.innerHTML = 'add'
  mapGroupZoom.appendChild(zoomInButton)

  var zoomOutButton = document.createElement('button')
  zoomOutButton.classList.add('maps-button')
  zoomOutButton.innerHTML = 'remove'
  mapGroupZoom.appendChild(zoomOutButton)

  var positionButton = document.createElement('button')
  positionButton.classList.add('maps-button')
  positionButton.innerHTML = 'my_location'
  mapGroupLocation.appendChild(positionButton)

  controls.appendChild(mapGroupZoom)
  controls.appendChild(mapGroupLocation)

  map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controls)

  var currentZoomLevel = map.getZoom() || 16

  zoomInButton.addEventListener('click', () => {
    map.setZoom(currentZoomLevel + 1)
  })

  zoomOutButton.addEventListener('click', () => {
    map.setZoom(currentZoomLevel - 1)
  })

  positionButton.addEventListener('click', () => {
    goToCurrentLocation(map)
  })
}
